import React from 'react'
import { setDateFormat, setTimeFormat } from '../../../../utils/dateUtils'
import { Typography, Grid } from '@mui/material'
import {
  fontLetterSpacings,
  fontLineHeights,
  fontSizes,
  fontWeights,
} from '../../../Common/Typography/TypographyStyles'

interface TaskDueDateFormatProps {
  value: string // Assuming the value is a string representing a date
}

const TaskDueDateFormat: React.FC<TaskDueDateFormatProps> = ({ value }) => {
  return (
    <Grid container spacing={0} direction='column' alignContent='center'>
      <Grid>
        <Typography
          sx={{
            fontSize: fontSizes.size12,
            fontWeight: fontWeights[700],
            lineHeight: fontLineHeights.ratio9to8,
            letterSpacing: fontLetterSpacings.loose,
          }}
        >
          {setDateFormat(value)}
        </Typography>
      </Grid>
      <Grid>
        <Typography
          sx={{
            fontSize: fontSizes.size12,
            lineHeight: fontLineHeights.ratio9to8,
            letterSpacing: fontLetterSpacings.loose,
          }}
        >
          {setTimeFormat(value)}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default TaskDueDateFormat
